import { z } from 'zod';
import { brandCodeSchema } from './enums.js';
const ORDER_KEYS = [
    'website',
    'websiteUrl',
    'name',
    'order_number',
    'event_name',
    'order_total',
    'order',
    'first_name',
    'last_name',
    'email',
    'totalproducts',
    'totalprice',
];
export const PASSTHROUGH_TEMPLATES = {
    OrderPaid: {
        template: 'OrderPaid',
        code: 'T01',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: ORDER_KEYS,
        oneOf: ['account_link', 'activate_link'],
        links: ['account_link', 'activate_link'],
        order: true,
    },
    OrderCreatedWithBankTransfer: {
        template: 'OrderCreatedWithBankTransfer',
        code: 'T02',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: [...ORDER_KEYS, 'bank_details'],
        oneOf: ['account_link', 'activate_link'],
        links: ['account_link', 'activate_link'],
        order: true,
    },
    UnpaidOrderReminder: {
        template: 'UnpaidOrderReminder',
        code: 'T03',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: [...ORDER_KEYS, 'payment_link'],
        links: ['payment_link'],
        order: true,
    },
    ShippingTicketsOld: {
        template: 'ShippingTicketsOld',
        code: 'T04',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: [...ORDER_KEYS, 'ticket_link'],
        links: ['ticket_link'],
        order: true,
    },
    SupportReply: {
        template: 'SupportReply',
        code: 'T06',
        validForMinutes: null,
        maxScheduleHours: 720,
        required: ['subject', 'support_reply_body'],
        links: [],
        order: false,
    },
    ContactFormRecap: {
        template: 'ContactFormRecap',
        code: 'T07',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: ['contact_form_summary', 'first_name', 'task_number', 'website', 'websiteUrl'],
        links: [],
        order: false,
    },
    CustomerActivate: {
        template: 'CustomerActivate',
        code: 'T08',
        validForMinutes: 20160,
        maxScheduleHours: 24,
        required: ['activation_link', 'website', 'websiteUrl'],
        links: ['activation_link', 'websiteUrl'],
        order: false,
    },
    CustomerResetPassword: {
        template: 'CustomerResetPassword',
        code: 'T09',
        validForMinutes: 1440,
        maxScheduleHours: 24,
        required: ['reset_link', 'first_name', 'website', 'websiteUrl'],
        links: ['reset_link', 'websiteUrl'],
        order: false,
    },
    FlexiUsed: {
        template: 'FlexiUsed',
        code: 'T11',
        validForMinutes: null,
        maxScheduleHours: 24,
        required: ['flexi_code', 'first_name', 'website', 'websiteUrl'],
        links: ['websiteUrl'],
        order: false,
    },
};
export const PASSTHROUGH_CODES = Object.values(PASSTHROUGH_TEMPLATES)
    .map((t) => t.code)
    .sort();
const RESERVED = { Shipping: 'T10' };
const REPLACED = { WatchdogTicketsAvailable: 'T05' };
/** `UnfinishedCartReminder` (čeká na rozhodnutí CEO/právníka, F115) a cokoli neznámé je `unknown`: do API nepatří. */
export function classifyShopTemplate(template) {
    const p = PASSTHROUGH_TEMPLATES[template];
    if (p)
        return { kind: 'passthrough', code: p.code };
    const r = RESERVED[template];
    if (r)
        return { kind: 'reserved', code: r };
    const x = REPLACED[template];
    if (x)
        return { kind: 'replaced', code: x };
    return { kind: 'unknown' };
}
/** Tělo `POST /v1/transactional-messages/passthrough`: tvar `POST emails` e-mailové služby + `idempotency_key` a `brand`. */
export const shopBodySchema = z.object({
    idempotency_key: z
        .string()
        .regex(/^[A-Za-z0-9._:-]{8,200}$/, '8 až 200 znaků A-Z a-z 0-9 . _ : -'),
    brand: brandCodeSchema,
    template: z.string().min(1).max(100),
    senderEmail: z.string().email(),
    senderName: z.string().min(1).max(200),
    recipientEmail: z.string().email(),
    lang: z.string().regex(/^[a-z]{2}$/, 'Jazyk: dvě malá písmena.'),
    tag: z.string().max(200).nullish(),
    scheduledDate: z.number().int().positive().nullish(),
    parameters: z.record(z.unknown()),
    source: z.string().max(200).nullish(),
    userName: z.string().max(200).nullish(),
    userType: z.string().max(50).nullish(),
    attachments: z
        .array(z.object({
        name: z.string().max(200),
        extension: z.string().max(10),
        fileName: z.string().min(1).max(200),
        content: z.string().min(1),
    }))
        .max(5)
        .default([]),
    bulkName: z.string().nullish(),
    bcc: z.array(z.string()).max(0).default([]),
});
//# sourceMappingURL=transactional-passthrough.js.map